
import styles from './index.module.scss'
import { useLocation } from 'react-router-dom';

export default function ErrorPage({dynamicLocations}) {
  let location = useLocation();
  if (!dynamicLocations || dynamicLocations.length === 0)
    return <></>
  if (dynamicLocations && dynamicLocations.includes(location))
  {
    return <></>
  }

  return (
    <div className={styles.NotFound}>
      <div className="alert alert-danger" role="alert">404 Page Not Found</div>
    </div>
  );
}